import React from 'react';
import Board from './board';
import SidebarWb from './sidebarWb';
import { ViewRoot } from './styles';

interface WorkboardViewProps {
  active: boolean;
}

const WorkboardView: React.FC<WorkboardViewProps> = ({ active }) => (
  <ViewRoot $active={active}>
    <SidebarWb />
    <Board />
  </ViewRoot>
);

export default WorkboardView;
